export function getById (state) {
	return id => state.clubs.find(club => club.id === id);
}
